// extracted by mini-css-extract-plugin
export default {"main_wrapper":"Post_main_wrapper__Zrru6","link_back":"Post_link_back__h+Qr0"};